import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';

function ConfirmDialog({ open, message, details, confirmLabel, cancelLabel, onConfirm, onClose }) {
  const { t } = useTranslation();

  return (
    <Modal open={open} title={t('confirm.title')} onClose={onClose}>
      <p className="text-sm">{message}</p>
      {details && (
        <div className="mt-3 rounded-md border border-[color:var(--app-border)] bg-[color:var(--app-card)] px-3 py-2.5">
          {details}
        </div>
      )}
      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={onClose}
          className="flex-1 rounded-md border border-[color:var(--app-border)] px-3 py-2.5 text-sm transition hover:border-emerald-500/40"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="flex-1 rounded-md bg-red-600 px-3 py-2.5 text-sm font-medium text-white transition hover:bg-red-500"
        >
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}

export default ConfirmDialog;
